export default "__VITE_ASSET__MOiNwbwi__"